// import auth from 'src/router/auth'
// import Dashboard from '../Dashboard'

export default [
  // {
  //   path: '/',
  //   name: 'dashboard',
  //   component: Dashboard,
  //   beforeEnter: auth.requireAuth
  // }
]



// WEBPACK FOOTER //
// ./src/components/dashboard/routes/index.js